import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var exampleArticle = {
  "Title": "FamilyFun Magazine Names Cracker Barrel Old Country Store&reg;",
  "Summary": "<p><strong>LEBANON, TENN.</strong>, March 23, 2015 – Cracker Barrel Old Country Store&reg; was named a top family-friendly restaurant by <strong>FamilyFun</strong> magazine in its third annual Travel Awards. Chosen by 2,000 families from across the country, the winners were announced in the magazine’s April issue.</p>",
  "PublishedDate": "3/22/2015 11:00:00 PM",
  "ImageSrc": "/-/media/CrackerBarrel/Newsroom/Articles/FamilyFunBadge1_thumb.jpg",
  "ImageAlt": "Family Fun Travel Awards Logo",
  "VideoUrl": "",
  "PageUrl": "/newsroom/news-releases/2015/mar/familyfun-magazine-names"
};
var exampleCard = {
  image: {
    'value': {
      'src': '/images/sample-content/Holiday_HnS_1440x390.jpg',
      'alt': 'Holiday Heat n\' Serve',
      'title': 'Holiday Heat n\' Serve'
    }
  },
  link1: {
    value: {
      'text': 'Add to Order',
      'title': 'Add to Order',
      'href': '#',
      'class': 'cb-button-primary'
    }
  },
  link2: {
    value: {
      'text': 'Customize',
      'title': 'Customize',
      'href': '#',
      'class': 'cb-button-secondary'
    }
  },
  title: {
    value: 'Grandpa\'s Country Breakfast'
  },
  subtitle: {
    value: 'Holiday Heat n’ Serve Family Meal To-Go'
  },
  text: {
    value: 'Two eggs, grits, choice of meat w/ gravy.'
  },
  cardColor: {
    fields: {
      value: {
        value: 'color1'
      }
    }
  },
  cost: {
    value: "$7.97"
  },
  calorie: {
    value: "550 cal"
  },
  likes: {
    value: "135"
  },
  linkType: {
    value: 'default'
  },
  year: {
    value: "2019"
  },
  available: {
    value: "Available: Fri - until 7pm"
  }
}; // {"Summary":"<p>Cracker Barrel Delivery is available in select stores. To see if delivery* is available at your local Cracker Barrel, please visit our&nbsp;<a href=\"/Locations\">Store Directory</a>&nbsp;and search for your location. When placing an order online, you will have the option to choose delivery if it is available for your location. Please feel free to contact your local Cracker Barrel if you have any questions. Cracker Barrel is also available on popular apps such as DoorDash and Postmates. </p>\n<br />\n<small>*At participating locations. Delivery hours and delivery radius may vary. Minimum order required and delivery fees apply.</small>","PublishedDate":null,"ImageSrc":"/-/media/CrackerBarrel/Newsroom/Articles/CB_Logo_RGB_300dpi_thumb.jpg","Price":null,"Basecalories":null,"Maxcalories":null,"Availability":null,"ImageAlt":"Cracker Barrel Logo","VideoUrl":null,"PageUrl":"/connect/faqs"}

export var articlestocards = function articlestocards(articles) {
  /*
    Decide if Article,
    if yes, do this function
  */
  var cards = articles.map(function (article) {
    var _fields;

    var Title = article.Title,
        Price = article.Price,
        ImageSrc = article.ImageSrc,
        ImageAlt = article.ImageAlt,
        VideoUrl = article.VideoUrl,
        Summary = article.Summary,
        PublishedDate = article.PublishedDate,
        Basecalories = article.Basecalories,
        Maxcalories = article.Maxcalories,
        Availability = article.Availability,
        PageUrl = article.PageUrl,
        Id = article.Id,
        IsRetail = article.IsRetail,
        _article$ShortDescrip = article.ShortDescription,
        ShortDescription = _article$ShortDescrip === void 0 ? "" : _article$ShortDescrip;
    var listPriceBool = !isNaN(parseFloat(Price));
    var baseCalBool = Boolean(parseInt(Basecalories));
    var date = Boolean(PublishedDate) ? PublishedDate : "";
    return {
      fields: (_fields = {
        title: {
          value: Title
        },
        price: {
          value: Price
        },
        productId: Id,
        image: {
          value: {
            src: ImageSrc,
            alt: ImageAlt
          }
        },
        video: {
          value: {
            src: VideoUrl
          }
        },
        link1: {
          value: {
            'text': 'Read More',
            'title': 'Read More',
            'href': PageUrl,
            'class': 'cb-button-primary'
          }
        },
        link3: {
          value: {
            'text': '',
            'title': '',
            'href': PageUrl,
            'class': ''
          }
        },
        subtitle: {
          value: ""
        },
        text: {
          value: "<div class=\"cb-content-block__text\">".concat(Summary, "</div>")
        },
        cardColor: {
          fields: {
            value: {
              value: 'color1'
            }
          }
        }
      }, _defineProperty(_fields, "price", {
        value: "".concat(listPriceBool ? "".concat(Price === 0 ? "" : "$".concat(parseFloat(Price).toFixed(2))) : date)
      }), _defineProperty(_fields, "calorie", {
        value: baseCalBool ? "".concat(Basecalories).concat(Maxcalories === "0" ? "" : "-".concat(Maxcalories), " cal") : ""
      }), _defineProperty(_fields, "available", {
        value: "".concat(!!Availability ? Availability : "")
      }), _defineProperty(_fields, "isRetailSearch", IsRetail), _fields)
    };
  });

  if (cards.length === 0) {
    cards.push({
      fields: {}
    });
  }

  return cards;
};